import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { _ } from '_locales';
import images from '_images';
import HOC from '_HOC';
import { goToTop } from '_helpers';

import * as actions from '../redux/actions';

const Container = styled.div`
    width: 100%;
    max-width: 580px;
    padding: 45px 35px;
    box-sizing: border-box;
    margin: 0 auto;
    min-height: 350px;
`;

const Title = styled.h3`
    font-size: 20px;
    font-weight: 400;
    font-family: Roboto, sans-serif;
    color: #000;
    text-align: left;
`;

const Problem = styled.button`
    display: flex;
    height: 45px;
    border: none;
    border-bottom: 1px solid #cccccc;
    margin: 10px 0 !important;
    padding: 0;
    padding-bottom: 10px;
    background-color: transparent;
    cursor: pointer;
    width: 100%;
    text-align: left;
    align-items: center;
`;

const ProblemTitleHolder = styled.div`
  flex: 1;
  padding: 0 10px;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const ProblemTitle = styled.p`
    flex: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

const ProblemArrowHolder = styled.div`
  flex: 1;
  max-width: 17px !important;
  padding: 10px 0 !important;
`;

const ProblemArrow = styled.img`
  width: 100%;
  height: 100%;
`;

const OtherProblems = ({
  plugin, config, setFromHelp, props
}) => {
  const { districtId } = config;
  const { storeDistricts: districts } = plugin;
  const { history } = props;

  return (
    <Container>
      <Title>{_('help.what_type_of_issue_are_you_having')}</Title>
      <ul style={{ padding: 0 }}>
        {
          districts[districtId].problem_types
            .filter(({ display_opt }) => display_opt !== 'P')
            .map(({ problem_type_label: label, problem_type_cd: type }) => (
              <li style={{ listStyle: 'none' }}>
                <Problem
                  key={`${label}@${type}`}
                  onClick={() => [
                    goToTop(),
                    setFromHelp(false),
                    history.push('/help/form-page', {
                      type,
                      title: label,
                      formDesc: 'none',
                      description: _('help.please_complete_and_submit_this_form')
                    })]}
                >
                  <ProblemTitleHolder>
                    <ProblemTitle>{label}</ProblemTitle>
                  </ProblemTitleHolder>

                  <ProblemArrowHolder>
                    <ProblemArrow src={images.calendar.rightArrow} alt="check the details" />
                  </ProblemArrowHolder>
                </Problem>
              </li>
            ))
        }
      </ul>

    </Container>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setFromHelp: (fromHelp) => dispatch(actions.setFromHelp(fromHelp)),
});

export default HOC(connect(null, mapDispatchToProps)(OtherProblems));
